import {
	AppBar,
} from '@mui/material'
import type {
	JSX,
} from 'react'

import {
	HStack,
} from '@/shared/components/stack'

import {
	Logo,
} from './navbar-base.styles'

export const NavbarBase = (): JSX.Element => {
	return (
		<AppBar
			position='static'
			sx={{
				paddingTop: 'var(--tg-content-safe-area-inset-top)',
			}}
		>
			<HStack pt={2} alignItems='center' justifyContent='space-between'>
				<Logo>
					<img alt='Logo' src='/assets/images/logo.svg' />
				</Logo>

				{/* <IconButton size='small'>
					<SvgIcon>
						<SettingsIcon />
					</SvgIcon>
				</IconButton> */}
			</HStack>

		</AppBar>
	)
}
